import React from 'react';

import { useTranslation } from 'react-i18next';

import { Modal, Button } from 'design-system-web';
import { S, M } from 'components/typography';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  applying: boolean;
  totalTargets: number;
  alreadyEnabledCount: number;
  toEnableCount: number;
  moduleTitleKey: string;
};

export function BulkModulePreviewModal({
  isOpen,
  onClose,
  onConfirm,
  applying,
  totalTargets,
  alreadyEnabledCount,
  toEnableCount,
  moduleTitleKey,
}: Props) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t(
        'web.admin.portalManagement.channelModulesBulk.preview.modal.title'
      )}
      size="small"
      closeButtonSize="small"
      actions={
        <>
          <Button
            onClick={onConfirm}
            loading={applying}
            disabled={applying || toEnableCount === 0}
          >
            {t(
              'web.admin.portalManagement.channelModulesBulk.preview.modal.apply'
            )}
          </Button>
          <Button variant="secondary" onClick={onClose} disabled={applying}>
            {t(
              'web.admin.portalManagement.channelModulesBulk.preview.modal.cancel'
            )}
          </Button>
        </>
      }
    >
      <M mb={4}>
        {t(
          'web.admin.portalManagement.channelModulesBulk.preview.modal.summary',
          {
            moduleTitle: t(moduleTitleKey),
            totalTargets,
            alreadyEnabledCount,
            toEnableCount,
          }
        )}
      </M>
      {toEnableCount === 0 && (
        <S>
          {t(
            'web.admin.portalManagement.channelModulesBulk.preview.modal.allAlreadyEnabled'
          )}
        </S>
      )}
    </Modal>
  );
}
